export default __webpack_public_path__ + "static/media/feet_hobbit_edit.a4c592c8.png";